import React, { useCallback } from "react";
import ModalWrapper from "..";
import { Button } from "../../button";
import toast from "react-hot-toast";
import { useDeleteVisitPurpose } from "../../../hooks/user/mutation";
import { useTranslation } from "react-i18next";
import StatusCodes from "../../../constants/StatusCodes";

interface DeleteVisitPurposeModalProps {
  purposeDetails: {
    purposeId: number;
    locationId: number;
  };
  isOpen: boolean;
  onOpenChange: () => void;
}

const DeleteVisitPurposeModal = ({
  purposeDetails,
  isOpen,
  onOpenChange,
}: DeleteVisitPurposeModalProps) => {
  const { t } = useTranslation();

  const {
    mutateAsync: DeleteVisitPurpose,
    isPending: isDeleteVisitPurposeLoading,
  } = useDeleteVisitPurpose();

  const handleDeleteVisitPurpose = useCallback(async () => {
    try {
      const body = {
        purposeId: purposeDetails.purposeId,
        locationId: purposeDetails.locationId,
      };

      await DeleteVisitPurpose(body);
      toast.success(t("visitPurposeDeleted"));
    } catch (error: any) {
      if (error.statusCode === StatusCodes.BAD_REQUEST) {
        toast.error(t("visitPurposeInUse"));
      } else {
        toast.error(t("somethingWentWrong"));
      }
    } finally {
      onOpenChange();
    }
  }, [
    DeleteVisitPurpose,
    onOpenChange,
    purposeDetails.locationId,
    purposeDetails.purposeId,
    t,
  ]);

  return (
    <ModalWrapper isOpen={isOpen} onOpenChange={onOpenChange}>
      <div className="flex flex-col gap-8 justify-center items-center">
        <p className="text-lg md:text-2xl font-medium">
          {t("confirmDeleteVisitPurpose")}
        </p>

        <div className="flex gap-1 items-center">
          <Button
            onClick={handleDeleteVisitPurpose}
            isLoading={isDeleteVisitPurposeLoading}
            className=" bg-red-600 hover:bg-red-700"
          >
            {t("delete")}
          </Button>

          <Button onClick={onOpenChange}>{t("close")}</Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default React.memo(DeleteVisitPurposeModal);
